/**
 * Task prerequisites: the dependency edge as the server sends it and the
 * one request that replaces a task's prerequisite set.
 */

import { request } from './request.js';

export interface TaskDependencyView {
  readonly taskId: string;
  readonly reference: string;
  readonly title: string;
  readonly status: string;
  readonly taskType: string;
}

export function replaceTaskDependencies(
  idempotencyKey: string,
  taskId: string,
  body: { expectedVersion: number; prerequisiteTaskIds: readonly string[] },
): Promise<{ taskId: string; version: number; changed: boolean }> {
  return request(
    'POST',
    `/workspace/tasks/${encodeURIComponent(taskId)}/dependencies`,
    { body, idempotencyKey },
  );
}
